import { SidenavLink } from "./sidenav.controller";

angular
    .module("thor.shared.sidenav.link.component", [])
    .component("thorSidenavLink", {
        bindings: {
            checkRestriction: "&",
            link: "<"
        },
        controller: class {
            public checkRestriction: Function;
            public link: SidenavLink;
        },
        template: require("../../shared/sidenav/link.html")
    });
